import {
  // -- GET (list)
  // GET_FLOW_CONDITIONS_SUCCESS,
  // GET_FLOW_CONDITIONS_FAILURE,
  // -- UPDATE
  UPDATE_FLOW_CONDITION_SUCCESS,
  UPDATE_FLOW_CONDITION_FAILURE
} from '../../actions'
import { Logger, LoggerTypes } from '../../utils'

// let cacheItems = null

export const flowConditions = (state = {}, action) => {
  switch (action.type) {
    // -- GET FLOW CONDITION (list)
    // case GET_FLOW_CONDITIONS_FAILURE: {
    //   Logger.trace(LoggerTypes.WARN, '[REDUCER] flowConditions.GET_FLOW_CONDITIONS_FAILURE()', { state, action })
    //   return { ...state, error: action.data }
    // }
    // case GET_FLOW_CONDITIONS_SUCCESS: {
    //   cacheItems = action.data || []

    //   Logger.trace(LoggerTypes.REDUCER, '[REDUCER] flowConditions.GET_FLOW_CONDITIONS_SUCCESS()', { state, action })

    //   return {
    //     ...state,
    //     items: cacheItems
    //   }
    // }

    // -- UPDATE A FLOW CONDITION
    case UPDATE_FLOW_CONDITION_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] flowConditions.UPDATE_FLOW_CONDITION_FAILURE()', { state, action })
      return { ...state, error: action.data }
    }
    case UPDATE_FLOW_CONDITION_SUCCESS: {
      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] flowConditions.UPDATE_FLOW_CONDITION_SUCCESS()', { state, action })

      return {
        ...state,
        ...action.data
      }
    }

    default:
      return state
  }
}
